// CMS API Client for Campen Camping
const API_BASE = 'https://api.dev.auxo.dk/public';

// Fallback data matching the exact shape of the CMS collections
export const FALLBACK_PAGES = [
  {
    id: "fe277677-57f7-4d5c-9bda-3b6555081080",
    slug: { da: "home" },
    title: { da: "Forside" },
    meta_title: { da: "Campen Camping – Feriehuse, Hytter, Campingvogne. God stemning og havudsigt." },
    meta_description: { da: "Hos Campen Camping på Samsø kan du leje hytter, feriehuse, campingvogne og teltpladser or leje hele pladsen til events og selskaber. God stemning og havudsigt." },
    content: { da: "<p>Velkommen til Campen Camping – din fredelige oase på Sydsamsø med overdådig havudsigt og ægte ø-stemning.</p>" }
  },
  {
    id: "56acbf29-b4ca-44f1-b40d-1dfe48fb483b",
    slug: { da: "feriehuse" },
    title: { da: "Feriehuse" },
    meta_title: { da: "Feriehuse & Hytter på Samsø - Campen Camping" },
    meta_description: { da: "Se vores store udvalg af feriehuse, hytter og campingvogne til udlejning på Samsø. Plads til 2-24 personer med fantastisk havudsigt." },
    content: { da: "<p>Udforsk vores udvalg af feriehuse, hytter og hyggelige campingvogne. Vi har plads til alt fra parferie til store familietræf.</p>" }
  },
  {
    id: "e3bf5274-91b3-4c2f-8586-05e08def22cc",
    slug: { da: "lej-campen" },
    title: { da: "Lej Campen" },
    meta_title: { da: "Lej hele pladsen til events, selskaber & bryllup - Campen Camping" },
    meta_description: { da: "Hold dit næste arrangement, bryllup eller firmaevent hos Campen Camping. Plads til 100 spisende i klubhuset og 100 overnattende gæster." },
    content: { da: "<p>Book hele pladsen til events, bryllup, virksomhedsarrangementer & kurser. Vi har plads til ca. 100 spisende i klubhuset og ca. 100 sovende i feriehuse, hytter, værelser og campingvogne.</p>" }
  },
  {
    id: "1ea26eac-8c0c-41a8-b888-edeb41eb3b39",
    slug: { da: "om-campen" },
    title: { da: "Om Campen Camping" },
    meta_title: { da: "Om Campen Camping - Fredelig campingplads på Samsø" },
    meta_description: { da: "Læs mere om Campen Camping på Samsø. Beliggende på Sydøen med egen badebro, fantastiske solnedgange, gode fiskeforhold og hyggelige rammer." },
    content: { da: "<p>Samsø er en charmerende ferieø midt i Danmark, hvor livet går lidt langsommere, og naturen får lov at fylde. Øens sydligste campingplads er smukt beliggende med en overdådig havudsigt mod vest. Pladsen har sin egen badebro og er berømt for sine vidunderlige solnedgange.</p>" }
  },
  {
    id: "09d2e25c-4508-479e-a91d-1eec48aae9ff",
    slug: { da: "kontakt" },
    title: { da: "Kontakt" },
    meta_title: { da: "Kontakt os - Campen Camping" },
    meta_description: { da: "Har du spørgsmål eller ønsker du at booke? Kontakt Campen Camping på Samsø. Ring på +45 5154 0023 eller skriv til info@campencamping.dk." },
    content: { da: "<p>Du er altid velkommen til at kontakte os, hvis du har spørgsmål til priser, faciliteter, booking eller leje af hele pladsen.</p>" }
  },
  {
    id: "90f819aa-a3ac-4787-9f9d-de54a5e5ce48",
    slug: { da: "forretningsbetingelser" },
    title: { da: "Forretningsbetingelser" },
    meta_title: { da: "Forretningsbetingelser - Campen Camping" },
    meta_description: { da: "Læs vores forretningsbetingelser for booking, afbestilling, ordensregler og leje af faciliteter hos Campen Camping på Samsø." },
    content: { da: "<p>Her finder du vores gældende forretningsbetingelser for ophold og leje.</p>" }
  }
];

export const FALLBACK_ACCOMMODATIONS = [
  // --- FERIEHUSE ---
  {
    id: "701",
    slug: { da: "hammerslaget" },
    title: { da: "Hammerslaget" },
    type: { da: "Feriehus" },
    capacity: 18,
    size: "230m²",
    price_info: { da: "fra 1.000,00 DKK" },
    description: { da: "<p>Nyd en afslappende ferie i dette rummelige sommerhus med smuk udsigt over vandet.</p><p>18 sovepladser fordelt på 9 værelser. 4 badeværelser med bad og toilet.</p><p>Velkommen i et dejligt feriehus med store rum og gode hyggekroge. Her er der lagt op til et ophold, der byder på både afslapning og variation. De forskellige siddeområder giver mulighed for fælles måltider, spilleaftener eller rolige stunder med en bog. Sæt jer godt til rette ved spisebordet eller brug den hyggelige sofakrog til de afslappende aftener med fjernsyn. Det rummelige køkken giver jer mulighed for at gøre madlavningen til et fællesprojekt. Brændeovnen sørger for varme og ekstra stemning på de kølige dage.</p><p>Træd ud på den store terrasse og vælg en af de mange siddepladser udendørs. Her er der en dejlig ro og ugenerte rammer. D88001</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88001-main-01.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88001-outdoor-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88001-outdoor-02-768x489.jpg"
    ],
    novasol_link: "https://www.novasol.dk/feriehuse/kolby-ks-d88001",
    facilities: { da: "Bad, Brændeovn, DK Stikkontakt [230V / 50Hz], Elvarme, Fryser, Gasgrill, Kaffemaskine, Køkken, Køleskab, Mikroovn, Opvaskemaskine, Støvsuger, Tekøkken, Toilet, Tørretumbler, Varmepumpe, Vaskemaskine, Wi-Fi" },
    view: { da: "Havudsigt" },
    beds: { da: "18 senge" }
  },
  {
    id: "702",
    slug: { da: "det-lille-slag" },
    title: { da: "Det lille slag" },
    type: { da: "Feriehus" },
    capacity: 4,
    size: "90m²",
    price_info: { da: "fra 800,00 DKK" },
    description: { da: "<p>Nyd en afslappende ferie i denne dejlige ferielejlighed med 4 sovepladser.</p><p>Lejligheden ligger umiddelbart opad hammerslaget som har 18 sovepladser.</p><p>Smuk udsigt over vandet og kun 300 meter til badebro.</p><p>Med store rum og gode hyggekroge. Her er der lagt op til et ophold, der byder på både afslapning og variation. De forskellige siddeområder giver mulighed for fælles måltider, spilleaftener eller rolige stunder med en bog. Sæt jer godt til rette ved spisebordet eller brug den hyggelige sofakrog til de afslappende aftener med fjernsyn. Det rummelige køkken giver jer mulighed for at gøre madlavningen til et fællesprojekt. Brændeovnen sørger for varme og ekstra stemning på de kølige dage.</p><p>Træd ud på den store terrasse og vælg en af de mange siddepladser udendørs. Her er der en dejlig ro og ugenerte rammer. D88002</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88002-outdoor-01.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88002-outdoor-02-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88002-living-05-768x489.jpg"
    ],
    novasol_link: "https://www.novasol.dk/feriehuse/kolby-ks-d88002",
    facilities: { da: "Bad, Brændeovn, DK Stikkontakt [230V / 50Hz], Elvarme, Fryser, Grill, Kaffemaskine, Køkken, Køleskab, Mikroovn, Opvaskemaskine, Støvsuger, Toilet, Tørretumbler, Varmepumpe, Vaskemaskine, Wi-Fi" },
    view: { da: "Havudsigt" },
    beds: { da: "4 senge" }
  },
  {
    id: "703",
    slug: { da: "kontorvognen" },
    title: { da: "Kontorvognen #703" },
    type: { da: "Feriehus" },
    capacity: 4,
    size: "40m²",
    price_info: { da: "fra 500,00 DKK" },
    description: { da: "<p>Nyd en afslappende ferie i dette rummelige sommerhus med smuk udsigt over vandet.</p><p>Velkommen i et dejligt feriehus med store rum og gode hyggekroge. Her er der lagt op til et ophold, der byder på både afslapning og variation. De forskellige siddeområder giver mulighed for fælles måltider, spilleaftener eller rolige stunder med en bog. Sæt jer godt til rette ved spisebordet eller brug den hyggelige sofakrog til de afslappende aftener med fjernsyn. Det rummelige køkken giver jer mulighed for at gøre madlavningen til et fællesprojekt. Brændeovnen sørger for varme og ekstra stemning på de kølige dage.</p><p>Træd ud på den store terrasse og vælg en af de mange siddepladser udendørs. Her er der een dejlig ro og ugenerte rammer. D88081</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88081-view-01.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88081-view-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88081-living-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88081-living-02-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88081-living-03-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88081-bed-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88081-bed-02-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88081-bed-03-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88081-bath-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88081-bath-02-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88081-bath-03-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88081-floorplan-01-768x489.png"
    ],
    novasol_link: "https://www.novasol.dk/feriehuse/kolby-ks-d88081",
    facilities: { da: "Bad, DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken, Toilet, Varmepumpe, Wi-Fi" },
    view: { da: "Havudsigt" },
    beds: { da: "4 senge" }
  },
  {
    id: "501",
    slug: { da: "feriehus-501" },
    title: { da: "Feriehus #501" },
    type: { da: "Feriehus" },
    capacity: 2,
    size: "25m²",
    price_info: { da: "fra 360,00 DKK" },
    description: { da: "<p>Glæd jer til et dejligt ophold i dette fine feriehus, som har en skøn udsigt over vandet og nem adgang til stranden. Velkommen til altid skønne Samsø og dette hyggelige hus. Her får I en perfekt base til at udforske øen og fylde ferien med en masse strandture. Boligen er moderne med enkle og behagelige indretningsløsninger samt et stort lysindfald fra vinduerne. D88083</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88083-main-02.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88083-main-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88083-main-03-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88083-associated-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88083-associated-02-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88083-living-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88083-living-02-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88083-bed-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88083-bed-02-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88083-bath-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88083-floorplan-01-768x489.png"
    ],
    novasol_link: "https://www.novasol.dk/feriehuse/kolby-ks-d88083",
    facilities: { da: "Bad, DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken, Toilet, Varmepumpe, Wi-Fi" },
    view: { da: "Havudsigt" },
    beds: { da: "2 senge" }
  },
  {
    id: "502",
    slug: { da: "feriehus-502" },
    title: { da: "Feriehus #502" },
    type: { da: "Feriehus" },
    capacity: 2,
    size: "25m²",
    price_info: { da: "fra 360,00 DKK" },
    description: { da: "<p>Glæd jer til et dejligt ophold i dette fine feriehus, som har en skøn udsigt over vandet og nem adgang til stranden. Velkommen til altid skønne Samsø og dette hyggelige hus. Her får I en perfekt base til at udforske øen og fylde ferien med en masse strandture. Boligen er moderne med enkle og behagelige indretningsløsninger samt et stort lysindfald fra vinduerne. D88084</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88084-main-02.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88084-outdoor-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88084-living-01-768x489.jpg"
    ],
    novasol_link: "https://www.novasol.dk/feriehuse/kolby-ks-d88084",
    facilities: { da: "Bad, DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken, Toilet, Varmepumpe, Wi-Fi" },
    view: { da: "Havudsigt" },
    beds: { da: "2 senge" }
  },
  {
    id: "503",
    slug: { da: "feriehus-503" },
    title: { da: "Feriehus #503" },
    type: { da: "Feriehus" },
    capacity: 2,
    size: "25m²",
    price_info: { da: "fra 350,00 DKK" },
    description: { da: "<p>Glæd jer til et dejligt ophold i dette fine feriehus, som har en skøn udsigt over vandet og nem adgang til stranden. Velkommen til altid skønne Samsø og dette hyggelige hus. Her får I en perfekt base til at udforske øen og fylde ferien med en masse strandture. Boligen er moderne med enkle og behagelige indretningsløsninger samt et stort lysindfald fra vinduerne. D88087</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88087-main-01.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88087-outdoor-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88087-living-01-768x489.jpg"
    ],
    novasol_link: "https://www.novasol.dk/feriehuse/kolby-ks-d88087",
    facilities: { da: "Bad, DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken, Toilet, Varmepumpe, Wi-Fi" },
    view: { da: "Havudsigt" },
    beds: { da: "2 senge" }
  },
  {
    id: "508",
    slug: { da: "feriehus-508" },
    title: { da: "Feriehus #508" },
    type: { da: "Feriehus" },
    capacity: 2,
    size: "25m²",
    price_info: { da: "fra 350,00 DKK" },
    description: { da: "<p>Glæd jer til et dejligt ophold i dette fine feriehus, som har en skøn udsigt over vandet og nem adgang til stranden. Velkommen til altid skønne Samsø og dette hyggelige hus. Her får I en perfekt base til at udforske øen og fylde ferien med en masse strandture. Boligen is moderne med enkle og behagelige indretningsløsninger samt et stort lysindfald fra vinduerne. D88094</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88094-main-01.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88094-living-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88094-living-02-768x489.jpg"
    ],
    novasol_link: "https://www.novasol.dk/feriehuse/kolby-ks-d88094",
    facilities: { da: "Bad, DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken, Toilet, Varmepumpe, Wi-Fi" },
    view: { da: "Havudsigt" },
    beds: { da: "2 senge" }
  },
  {
    id: "513",
    slug: { da: "feriehus-513" },
    title: { da: "Feriehus #513" },
    type: { da: "Feriehus" },
    capacity: 2,
    size: "25m²",
    price_info: { da: "fra 350,00 DKK" },
    description: { da: "<p>Glæd jer til et dejligt ophold i dette fine feriehus, som har en skøn udsigt over vandet og nem adgang til stranden. Velkommen til altid skønne Samsø og dette hyggelige hus. Her får I en perfekt base til at udforske øen og fylde ferien med en masse strandture. Boligen er moderne med enkle og behagelige indretningsløsninger samt et stort lysindfald fra vinduerne. D88093</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88093-main-01.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88093-living-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88093-living-02-768x489.jpg"
    ],
    novasol_link: "https://www.novasol.dk/feriehuse/kolby-ks-d88093",
    facilities: { da: "Bad, DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken, Toilet, Varmepumpe, Wi-Fi" },
    view: { da: "Havudsigt" },
    beds: { da: "2 senge" }
  },
  {
    id: "514",
    slug: { da: "feriehus-514" },
    title: { da: "Feriehus #514" },
    type: { da: "Feriehus" },
    capacity: 2,
    size: "25m²",
    price_info: { da: "fra 350,00 DKK" },
    description: { da: "<p>Glæd jer til et dejligt ophold i dette fine feriehus, som har en skøn udsigt over vandet og nem adgang til stranden. Velkommen til altid skønne Samsø og dette hyggelige hus. Her får I en perfekt base til at udforske øen og fylde ferien med en masse strandture. Boligen er moderne med enkle og behagelige indretningsløsninger samt et stort lysindfald fra vinduerne. D88095</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88095-main-02.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88095-living-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88095-living-02-768x489.jpg"
    ],
    novasol_link: "https://www.novasol.dk/feriehuse/kolby-ks-d88095",
    facilities: { da: "Bad, DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken, Toilet, Varmepumpe, Wi-Fi" },
    view: { da: "Havudsigt" },
    beds: { da: "2 senge" }
  },
  {
    id: "530",
    slug: { da: "feriehus-530" },
    title: { da: "Feriehus #530" },
    type: { da: "Feriehus" },
    capacity: 2,
    size: "25m²",
    price_info: { da: "fra 360,00 DKK" },
    description: { da: "<p>Glæd jer til et dejligt ophold i dette fine feriehus, som har en skøn udsigt over vandet og nem adgang til stranden. Velkommen til altid skønne Samsø og dette hyggelige hus. Her får I en perfekt base til at udforske øen og fylde ferien med en masse strandture. Boligen er moderne med enkle og behagelige indretningsløsninger samt et stort lysindfald fra vinduerne. D88096</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88096-main-02.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88096-living-01-920x650.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88096-living-02-920x650.jpg"
    ],
    novasol_link: "https://www.novasol.dk/feriehuse/kolby-ks-d88096",
    facilities: { da: "Bad, DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken, Toilet, Varmepumpe, Wi-Fi" },
    view: { da: "Havudsigt" },
    beds: { da: "2 senge" }
  },
  {
    id: "531",
    slug: { da: "feriehus-531" },
    title: { da: "Feriehus #531" },
    type: { da: "Feriehus" },
    capacity: 2,
    size: "25m²",
    price_info: { da: "fra 360,00 DKK" },
    description: { da: "<p>Glæd jer til et dejligt ophold i dette fine feriehus, som har en skøn udsigt over vandet og nem adgang til stranden. Velkommen til altid skønne Samsø og dette hyggelige hus. Her får I en perfekt base til at udforske øen og fylde ferien med en masse strandture. Boligen er moderne med enkle og behagelige indretningsløsninger samt et stort lysindfald fra vinduerne. D88089</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88089-main-01.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88089-living-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88089-living-02-768x489.jpg"
    ],
    novasol_link: "https://www.novasol.dk/feriehuse/kolby-ks-d88089",
    facilities: { da: "Bad, DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken, Toilet, Varmepumpe, Wi-Fi" },
    view: { da: "Havudsigt" },
    beds: { da: "2 senge" }
  },
  {
    id: "532",
    slug: { da: "feriehus-532" },
    title: { da: "Feriehus #532" },
    type: { da: "Feriehus" },
    capacity: 2,
    size: "25m²",
    price_info: { da: "fra 360,00 DKK" },
    description: { da: "<p>Glæd jer til et dejligt ophold i dette fine feriehus, som har en skøn udsigt over vandet og nem adgang til stranden. Velkommen til altid skønne Samsø og dette hyggelige hus. Her får I en perfekt base til at udforske øen og fylde ferien med en masse strandture. Boligen er moderne med enkle og behagelige indretningsløsninger samt et stort lysindfald fra vinduerne. D88090</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88090-outdoor-01.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88090-living-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88090-living-02-768x489.jpg"
    ],
    novasol_link: "https://www.novasol.dk/feriehuse/kolby-ks-d88090",
    facilities: { da: "Bad, DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken, Toilet, Varmepumpe, Wi-Fi" },
    view: { da: "Havudsigt" },
    beds: { da: "2 senge" }
  },
  {
    id: "533",
    slug: { da: "feriehus-533" },
    title: { da: "Feriehus #533" },
    type: { da: "Feriehus" },
    capacity: 2,
    size: "30m²",
    price_info: { da: "fra 360,00 DKK" },
    description: { da: "<p>Glæd jer til et dejligt ophold i dette fine feriehus, som har en skøn udsigt over vandet og nem adgang til stranden. Velkommen til altid skønne Samsø og dette hyggelige hus. Her får I en perfekt base til at udforske øen og fylde ferien med en masse strandture. Boligen er moderne med enkle og behagelige indretningsløsninger samt et stort lysindfald fra vinduerne. D88091</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88091-main-01.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88091-living-01-768x489.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88091-living-02-768x489.jpg"
    ],
    novasol_link: "https://www.novasol.dk/feriehuse/kolby-ks-d88091",
    facilities: { da: "Bad, DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken, Toilet, Varmepumpe, Wi-Fi" },
    view: { da: "Havudsigt" },
    beds: { da: "2 senge" }
  },

  // --- HYTTER ---
  {
    id: "510",
    slug: { da: "retro-hytte-510" },
    title: { da: "Retro Hytte #510" },
    type: { da: "Hytte" },
    capacity: 4,
    size: "16m²",
    price_info: { da: "fra 350,00 DKK" },
    description: { da: "<p>Hyggelig retro hytte med plads til 4 personer. Perfekt til den traditionelle campingferie i rolige omgivelser på Samsø.</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/1-4.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/2-4.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/3-4.jpg"
    ],
    novasol_link: "https://booking.campencamping.dk/accommodation/retro-hytte-510/",
    facilities: { da: "DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab" },
    view: { da: "Havudsigt" },
    beds: { da: "4 senge" }
  },
  {
    id: "516",
    slug: { da: "retro-hytte-516" },
    title: { da: "Retro Hytte #516" },
    type: { da: "Hytte" },
    capacity: 4,
    size: "16m²",
    price_info: { da: "fra 350,00 DKK" },
    description: { da: "<p>Hyggelig retro hytte med plads til 4 personer. Perfekt til den traditionelle campingferie i rolige omgivelser på Samsø.</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/1-1.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/2-1.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/3-1.jpg"
    ],
    novasol_link: "https://booking.campencamping.dk/accommodation/retro-hytte-516/",
    facilities: { da: "DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab" },
    view: { da: "Havudsigt" },
    beds: { da: "4 senge" }
  },
  {
    id: "600",
    slug: { da: "retro-hytte-600" },
    title: { da: "Retro Hytte #600" },
    type: { da: "Hytte" },
    capacity: 2,
    size: "12m²",
    price_info: { da: "fra 400,00 DKK" },
    description: { da: "<p>Hyggelig retro hytte med plads til 2 personer. Perfekt til den traditionelle campingferie i rolige omgivelser på Samsø.</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/1_2.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/2-2.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/3-2.jpg"
    ],
    novasol_link: "https://booking.campencamping.dk/accommodation/retro-hytte-a/",
    facilities: { da: "DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab" },
    view: { da: "Havudsigt" },
    beds: { da: "2 senge" }
  },

  // --- CAMPINGVOGNE ---
  {
    id: "517",
    slug: { da: "weisenberg-campingvogn" },
    title: { da: "Weisenberg Campingvogn #517" },
    type: { da: "Campingvogn" },
    capacity: 5,
    size: "35m²",
    price_info: { da: "fra 400,00 DKK" },
    description: { da: "<p>Oplev en unik ferie i vores store Weisenberg Campingvogn. Perfekt til familien, der ønsker en anderledes og hyggelig campingoplevelse med alle nødvendige bekvemmeligheder.</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/1-3.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/2-3.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/3-3.jpg"
    ],
    novasol_link: "https://booking.campencamping.dk/accommodation/weisenberg-campingvogn-517/",
    facilities: { da: "DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken" },
    view: { da: "Havudsigt" },
    beds: { da: "5 senge" }
  },
  {
    id: "507",
    slug: { da: "terry-amerikaner-campingvogn" },
    title: { da: "Terry Amerikaner Campingvogn #507" },
    type: { da: "Campingvogn" },
    capacity: 4,
    size: "35m²",
    price_info: { da: "fra 450,00 DKK" },
    description: { da: "<p>Oplev en unik ferie i vores store Terry Amerikaner Campingvogn. Perfekt til familien, der ønsker en anderledes og hyggelig campingoplevelse med alle nødvendige bekvemmeligheder.</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/1-1.png",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/2.jpg"
    ],
    novasol_link: "https://booking.campencamping.dk/accommodation/terry-amerikaner-campingvogn/",
    facilities: { da: "DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken" },
    view: { da: "Havudsigt" },
    beds: { da: "4 senge" }
  },
  {
    id: "504",
    slug: { da: "landhaus-campingvogn" },
    title: { da: "Landhaus Campingvogn #504" },
    type: { da: "Campingvogn" },
    capacity: 4,
    size: "30m²",
    price_info: { da: "fra 350,00 DKK" },
    description: { da: "<p>Oplev en unik ferie i vores hyggelige Landhaus Campingvogn. Perfekt til dig, der ønsker en anderledes og hyggelig campingoplevelse med alle nødvendige bekvemmeligheder.</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/1-2_1.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/c504kopi-768x576.jpeg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/c50410kopi-768x576.jpeg"
    ],
    novasol_link: "https://booking.campencamping.dk/accommodation/landhaus-campingvogn/",
    facilities: { da: "DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken" },
    view: { da: "Havudsigt" },
    beds: { da: "4 senge" }
  },
  {
    id: "509",
    slug: { da: "stor-retro-campingvogn" },
    title: { da: "Stor retro campingvogn #509" },
    type: { da: "Campingvogn" },
    capacity: 3,
    size: "25m²",
    price_info: { da: "fra 350,00 DKK" },
    description: { da: "<p>Oplev en unik ferie i vores store retro campingvogn. Perfekt til dig, der ønsker en anderledes og hyggelig campingoplevelse med alle nødvendige bekvemmeligheder.</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/6.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/2_1.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/3.jpg"
    ],
    novasol_link: "https://booking.campencamping.dk/accommodation/stor-retro-campingvogn-509/",
    facilities: { da: "DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken" },
    view: { da: "Havudsigt" },
    beds: { da: "3 senge" }
  },
  {
    id: "505",
    slug: { da: "retro-campingvogn-505" },
    title: { da: "Retro campingvogn #505" },
    type: { da: "Campingvogn" },
    capacity: 2,
    size: "20m²",
    price_info: { da: "fra 325,00 DKK" },
    description: { da: "<p>Oplev en unik ferie i vores hyggelige retro campingvogn. Perfekt til dig, der ønsker en anderledes og hyggelig campingoplevelse med alle nødvendige bekvemmeligheder.</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/1_1.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/2_1.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/3.jpg"
    ],
    novasol_link: "https://booking.campencamping.dk/accommodation/retro-campingvogn-505/",
    facilities: { da: "DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken" },
    view: { da: "Havudsigt" },
    beds: { da: "2 senge" }
  },
  {
    id: "518",
    slug: { da: "retro-campingvogn-518" },
    title: { da: "Retro campingvogn #518" },
    type: { da: "Campingvogn" },
    capacity: 2,
    size: "20m²",
    price_info: { da: "fra 300,00 DKK" },
    description: { da: "<p>Oplev en unik ferie i vores hyggelige retro campingvogn. Perfekt til dig, der ønsker en anderledes og hyggelig campingoplevelse med alle nødvendige bekvemmeligheder.</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/1-2.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/2_1.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/3.jpg"
    ],
    novasol_link: "https://booking.campencamping.dk/accommodation/retro-campingvogn-518/",
    facilities: { da: "DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken" },
    view: { da: "Havudsigt" },
    beds: { da: "2 senge" }
  },
  {
    id: "527",
    slug: { da: "retro-campingvogn-527" },
    title: { da: "Retro campingvogn #527" },
    type: { da: "Campingvogn" },
    capacity: 2,
    size: "20m²",
    price_info: { da: "fra 350,00 DKK" },
    description: { da: "<p>Oplev en unik ferie i vores hyggelige retro campingvogn. Perfekt til dig, der ønsker en anderledes og hyggelig campingoplevelse med alle nødvendige bekvemmeligheder.</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/1.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/2_1.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/3.jpg"
    ],
    novasol_link: "https://booking.campencamping.dk/accommodation/retro-campingvogn-527/",
    facilities: { da: "DK Stikkontakt [230V / 50Hz], Elvarme, Køleskab, Tekøkken" },
    view: { da: "Havudsigt" },
    beds: { da: "2 senge" }
  },

  // --- PLADSER (CAMPINGVOGN, AUTOCAMPER, STOR TELTPLADS) ---
  ...[4, 5, 6, 7, 10, 13, 14, 15, 16, 17, 18, 20].map(num => ({
    id: String(num),
    slug: { da: `campingvogn-autocamper-stor-teltplads-${num}` },
    title: { da: `Campingvogn, autocamper, stor teltplads #${num}` },
    type: { da: "Plads" },
    capacity: 10,
    size: "Stor plads",
    price_info: { da: "fra 250,00 DKK" },
    description: { da: `<p>Dejlig, fredelig plads til campingvogn, autocamper eller et stort telt med fantastisk havudsigt mod vest. Plads #${num} har sin egen charme og ligger tæt på pladsens faciliteter.</p><p>Pladsen har sin egen badebro og er berømt for sine vidunderlige solnedgange.</p>` },
    images: [
      `https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/t${num}.jpg`,
      `https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/t${num}-2.jpg`
    ].filter(url => url && !url.includes("t7-2.jpg")), // t7 has no t7-2.jpg in assets
    novasol_link: `https://booking.campencamping.dk/accommodation/campingvogn-autocamper-eller-stor-teltplads-${num}/`,
    facilities: { da: "DK Stikkontakt [230V / 50Hz]" },
    view: { da: "Havudsigt" },
    beds: { da: "Eget telt/vogn" }
  })),

  // --- TELTPLADSER ---
  ...["1A", "1B", "2A", "2B", "3A", "3B"].map(id => {
    const isB = id.endsWith("B");
    const baseNum = id.charAt(0);
    const mainImg = isB 
      ? `https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/t${baseNum}-2.jpg`
      : `https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/t${baseNum}.jpg`;
    const altImg = isB
      ? `https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/t${baseNum}.jpg`
      : `https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/t${baseNum}-2.jpg`;

    return {
      id: id,
      slug: { da: `teltplads-${id.toLowerCase()}` },
      title: { da: `Teltplads #${id}` },
      type: { da: "Plads" },
      capacity: 10,
      size: "Teltplads",
      price_info: { da: "fra 150,00 DKK" },
      description: { da: `<p>Dejlig, fredelig teltplads med fantastisk havudsigt mod vest. Plads #${id} er perfekt til dig, der ønsker å slå teltet op i naturskønne omgivelser med lyden af bølgeskvulp.</p><p>Pladsen har sin egen badebro og er berømt for sine vidunderlige solnedgange.</p>` },
      images: [mainImg, altImg],
      novasol_link: `https://booking.campencamping.dk/accommodation/teltplads-${id.toLowerCase()}/`,
      facilities: { da: "DK Stikkontakt [230V / 50Hz]" },
      view: { da: "Havudsigt" },
      beds: { da: "Eget telt" }
    };
  }),

  // --- AUTOCAMPER PARKERING PÅ P-PLADS ---
  ...["P1", "P2", "P3"].map(id => ({
    id: id,
    slug: { da: `parkering-autocamper-p-plads-${id.toLowerCase()}` },
    title: { da: `Parkering af autocamper på P-pladsen #${id}` },
    type: { da: "Plads" },
    capacity: 10,
    size: "P-plads",
    price_info: { da: "fra 150,00 DKK" },
    description: { da: `<p>Parkeringsplads #${id} til autocamper på P-pladsen. Perfekt til et hurtigt stop eller drop-ind overnatning med adgang til pladsens fælles faciliteter (bad, toilet, køkken og Wi-Fi).</p>` },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/m-32-610x608-1.png"
    ],
    novasol_link: "https://booking.campencamping.dk/accommodation/parkering-af-autocamper-paa-p-pladsen/",
    facilities: { da: "Badebro" },
    view: { da: "Havudsigt" },
    beds: { da: "Eget vogn" }
  })),

  // --- EVENTS ---
  {
    id: "704",
    slug: { da: "klubhuset" },
    title: { da: "Klubhuset #704" },
    type: { da: "Event" },
    capacity: 100,
    size: "252m²",
    price_info: { da: "fra 3.500,00 DKK" },
    description: { da: "<p>Et charmerende klubhus med plads til ca. 100 spisende personer. En uformel og indbydende atmosfære med dejlig havudsigt, ideelt til events, kurser og bespisning.</p><p>Huset rummer et fleksibelt opholdsrum med plads til både mødeopstilling, langborde eller caféopstilling, alt efter behov. Fra den store terrasse kan du sidde i havemøblerne og nyde den dejlige havudsigt.</p><p>Klubhuset kan nemt tilpasses både workshops, foredrag og firmaarrangementer. Der er mulighed for servering og fællesspisning i hyggelige omgivelser.</p><p>Stort anretterkøkken, to store grill på terrassen, fire toiletter heraf et handicaptoilet. Der er service til 120 personer.</p>" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/3.jpeg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/4.jpeg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/5.jpeg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/6.jpeg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/14.jpeg"
    ],
    novasol_link: "", // Goes to contact page
    facilities: { da: "DK Stikkontakt [230V / 50Hz], Elvarme, Køkken, Køleskab, Støvsuger, Toilet, Wi-Fi" },
    view: { da: "Havudsigt" },
    beds: null
  }
];

export const FALLBACK_GALLERIES = [
  {
    id: "1845f9cd-6426-49cb-b55a-7ec429030cf2",
    slug: { da: "feriehuse-hytter" },
    title: { da: "Feriehuse & Hytter" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88001-main-01.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88002-outdoor-01.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88081-view-01.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/d88091-main-01.jpg"
    ]
  },
  {
    id: "23f07ff5-17c4-4678-bf6d-e22f1271e3a3",
    slug: { da: "events-selskaber" },
    title: { da: "Events & Selskaber" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/3.jpeg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/4.jpeg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/5.jpeg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/6.jpeg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/14.jpeg"
    ]
  },
  {
    id: "58eadcd2-182e-442d-be89-8f46a7c65b2d",
    slug: { da: "campen-generelt" },
    title: { da: "Campen Generelt" },
    images: [
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/hyt14-scaled.jpg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/image34-scaled.jpeg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/image33-scaled.jpeg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/image31-scaled.jpeg",
      "https://assets.auxodev.dk/assets/d026a2b2-f90d-4c19-95d2-042cbc8d93d8/plads-oversigt-22-05-2026-sheet-a103-oversigtplan-hytte-conv-1-scaled.png"
    ]
  }
];

// Helper to fetch all items from a collection
export async function fetchCollection(collectionName, fallbackData) {
  try {
    const res = await fetch(`${API_BASE}/content/${collectionName}`);
    if (!res.ok) throw new Error(`Failed to fetch ${collectionName}`);
    const data = await res.json();
    return Array.isArray(data) && data.length > 0 ? data : fallbackData;
  } catch (err) {
    console.warn(`CMS Fetch failed for ${collectionName}, using fallback data.`, err);
    return fallbackData;
  }
}

// Public API methods
export async function fetchPages() {
  return fetchCollection('pages', FALLBACK_PAGES);
}

export async function fetchAccommodations() {
  // Always return the complete list of 45 units directly to bypass the old test items in the CMS
  return FALLBACK_ACCOMMODATIONS;
}

export async function fetchGalleries() {
  return fetchCollection('galleries', FALLBACK_GALLERIES);
}

export async function fetchPageBySlug(slugVal) {
  const pages = await fetchPages();
  return pages.find(p => p.slug?.da === slugVal || p.slug === slugVal) || FALLBACK_PAGES.find(p => p.slug?.da === slugVal);
}

export async function fetchAccommodationBySlug(slugVal) {
  const accs = await fetchAccommodations();
  return accs.find(a => a.slug?.da === slugVal || a.slug === slugVal) || FALLBACK_ACCOMMODATIONS.find(a => a.slug?.da === slugVal);
}

export async function fetchGalleryBySlug(slugVal) {
  const gals = await fetchGalleries();
  return gals.find(g => g.slug?.da === slugVal || g.slug === slugVal) || FALLBACK_GALLERIES.find(g => g.slug?.da === slugVal);
}
